// extracted by mini-css-extract-plugin
export default {"score":"PanelScore_score__vnTfU","scoreValue":"PanelScore_scoreValue__4wJDh"};